module.exports = __webpack_public_path__ + "static/media/ELS45NG02.46f3a08d.png";